import React, { useState } from 'react';

export default function B2BPaymentModal({ amount, onClose, onConfirm }) {
  const [method, setMethod] = useState('CB');

  return (
    <>
      <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmer le paiement</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <p className="fs-5 mb-4 text-center">Montant à régler : <strong>{amount ? amount.toFixed(2) : '0.00'} €</strong></p>
              
              <div className="mb-3">
                <label className="form-label">Mode de paiement</label>
                <select className="form-select" value={method} onChange={(e) => setMethod(e.target.value)}>
                  <option value="CB">Carte Bancaire (CB)</option>
                  <option value="Espèces">Espèces</option>
                  <option value="Virement">Virement</option>
                  <option value="Chèque">Chèque</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Annuler</button>
              <button type="button" className="btn btn-success" onClick={() => onConfirm(method)}>Confirmer le paiement</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
